import React, { useState } from "react";
import HeroLayout from "../components/HeroLayout";
import "yet-another-react-lightbox/styles.css";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";


const images = require.context("../assets/images", false);

function Car_Details() {
  const [index, setIndex] = useState(-1);
  const [activeSlide, setActiveSlide] = useState(0);

  const images1 = [
    { src: images("./Innova-Crysta-Exterior.jpg") },
    { src: images("./Innova-Crysta-Exterior-2.jpeg") },
    { src: images("./Innova-Crysta-Interior.jpg") },
    { src: images("./Innova-Crysta-Interior-1-1.jpeg") },
    { src: images("./Innova-Crysta-Interior-2-1.jpeg") },
    { src: images("./Innova-Crysta-Interior-3-1.jpeg") },    
  ];

const images2 = [
    { src: images("./Urbania.webp") },
    { src: images("./Vanluggagearea.webp") },
    { src: images("./Van3.webp") },
    { src: images("./Van1.webp") },
    { src: images("./Urbania1.webp") },
    { src: images("./Urbania2.webp") },    
  ];

  const NextArrow = ({ onClick }) => (
    <button className="custom-next next2 slick-arrow" onClick={onClick}>
      <img src={images("./Forward.svg")} alt="next arrow" />
    </button>
  );

  // Custom Prev Arrow
  const PrevArrow = ({ onClick }) => (
    <button className="custom-prev prev2 slick-arrow" onClick={onClick}>
      <img src={images("./backward.svg")} alt="prev arrow" />
    </button>
  );
 const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,           // ✅ AUTO SLIDE
    autoplaySpeed: 30000,      // 3 seconds
    speed: 600,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (oldIndex, newIndex) => {
      setActiveSlide(newIndex);
    }
  };

  return (
    <>
    <HeroLayout>
    <div
  className="banner-bg"
  style={{
    backgroundImage:
      `linear-gradient(#370b2e66, #370b2e66), url(${images("./cardetial.jpeg")})`
  }}
>
  <div className="container">
    <div className="inner-banner-content full-width center color-white mt-5">
      <h1>Car Details</h1>
    </div>
  </div>
</div>

    </HeroLayout>

   <div className="hotel-list car-details-page paddingY-70">
  <div className="container">
    <div className="heading center">
      <h2>Cars For Family &amp; Couple</h2>
    </div>
    <div className="row">
<div className="col-md-12">
    <div className="hotel-list-card-main">
    <div className="row align-items-center">
      <div className="col-md-6">
<div className="carousel-wrapper car-list-cards">

      <Slider {...settings}>
        {images1.map((img, i) => (
          <div key={i} className="slide-item">
            <img
              src={img.src}
              alt="car"
              onClick={() => setIndex(i)}
              className="carousel-image"
            />
          </div>
        ))}
      </Slider>

      <Lightbox
        open={index >= 0}
        close={() => setIndex(-1)}
        slides={images1}
        index={index}
      />
      </div></div>
      <div className="col-md-6">
  <div className="car-list-card-text">
    <h3 className="mb-2">Toyota Innova Crysta</h3>
    <p className="mb-2">
      <b>Vehicle Type:</b> MUV
    </p>
    <p className="mb-2">
      <b>Seating Capacity:</b> 5 (1 Front + 2 Middle + 2 Rear)
    </p>
    <p className="mb-2">
      <b>Suitable for:</b> 2 Adults + 2 Children OR 3 Adults
    </p>
    <p className="mb-2">
      <b>Remarks:</b> Standard car used in our tours. Comfortable and Spacious.
    </p>
  
  </div>
</div>

    </div>
</div>
</div>






      <div className="col-md-6">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="car-list-card">
                <img src={images("./Toyota-Fortuner.jpeg")} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="car-list-card-text mt-20 pl-20">
                <h3 className="mb-2">Toyota Fortuner</h3>
                <p className="mb-2">
                  <b>Vehicle Type:</b> SUV
                </p>
                <p className="mb-2">
                  <b>Seating Capacity:</b> 5 (1 Front + 2 Middle + 2 Rear)
                </p>
                <p className="mb-2">
                  <b>Suitable for:</b> 2 Adults + 2 Children OR 2 Adults
                </p>
            
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="car-list-card">
                <img src={images("./Mercedes-E-Class.jpeg")} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="car-list-card-text mt-20 pl-20">
                <h3 className="mb-2">Mercedes E & S Class</h3>
                <p className="mb-2">
                  <b>Vehicle Type:</b> Sedan
                </p>
                <p className="mb-2">
                  <b>Seating Capacity:</b> 3 (1 Front + 2 Rear)
                </p>
                <p className="mb-2">
                  <b>Suitable for:</b> 2 Adults + 1 Child OR 2 Adults
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-6">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="car-list-card">
                <img src={images("./Audi-Q7.jpeg")} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="car-list-card-text mt-20 pl-20">
                <h3 className="mb-2">Audi Q7</h3>
                <p className="mb-2">
                  <b>Vehicle Type:</b> Luxury SUV
                </p>
                <p className="mb-2">
                  <b>Seating Capacity:</b> 5 (1 Front + 2 Middle + 2 Rear)
                </p>
                <p className="mb-2">
                  <b>Suitable for:</b> 2 Adults + 2 Children OR 4 Adults
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="col-md-6">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="car-list-card">
                <img src={images("./Mercedes-GLS.jpeg")} className="car-image-contain car-image-gls" />
              </div>
            </div>
            <div className="col-md-12">
              <div className="car-list-card-text mt-20 pl-20">
                <h3 className="mb-2">Mercedes GLS</h3>
                <p className="mb-2">
                  <b>Vehicle Type:</b> Luxury SUV
                </p>
                <p className="mb-2">
                  <b>Seating Capacity:</b> 5 (1 Front + 2 Middle + 2 Rear)
                </p>
                <p className="mb-2">
                  <b>Suitable for:</b> 2 Adults + 2 Children OR 4 Adults
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>




  </div>
  <div className="container mt-80">
    <div className="heading center">
      <h2>Vehicles For Large Families &amp; groups</h2>
    </div>
    <div className="row">
      
<div className="col-md-12">
    <div className="hotel-list-card-main">
    <div className="row align-items-center">
      <div className="col-md-6">
<div className="carousel-wrapper car-list-cards">

      <Slider {...settings}>
        {images2.map((img, i) => (
          <div key={i} className="slide-item">
            <img
              src={img.src}
              alt="car"
              onClick={() => setIndex(i)}
              className="carousel-image"
            />
          </div>
        ))}
      </Slider>

      <Lightbox
        open={index >= 0}
        close={() => setIndex(-1)}
        slides={images1}
        index={index}
      />
      </div></div>
      <div className="col-md-6">
  <div className="car-list-card-text">
    <h3 className="mb-2">Force urbania</h3>
    <p className="mb-2">
      <b>Vehicle Type:</b> Mini Van
    </p>
    <p className="mb-2">
      <b>Seating Capacity:</b> 8-12 Seater
    </p>
    <p className="mb-2">
      <b>Suitable for:</b> 8-12 Adults
    </p>
    <p className="mb-2">
      <b>Remarks:</b> Standard van used for families & small groups. Comfortable and Spacious.
    </p>
  
  </div>
</div>

    </div>
</div>
</div>
      <div className="col-md-4">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="car-list-card">
                <img src={images("./Toyota-Hiace.jpg")} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="car-list-card-text mt-20 pl-20">
                <h3 className="mb-2">Toyota Hiace</h3>
                <p className="mb-2">
                  <b>Vehicle Type:</b> Minivan
                </p>
                <p className="mb-2">
                  <b>Seating Capacity:</b> 4 – 9 Seater
                </p>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="car-list-card">
                <img src={images("./Mercedes-V-Class.jpeg")} className="car-image-contain car-image-v-class" />
              </div>
            </div>
            <div className="col-md-12">
              <div className="car-list-card-text mt-20 pl-20">
                <h3 className="mb-2">Mercedes V Class</h3>
                <p className="mb-2">
                  <b>Vehicle Type:</b> Mini Van
                </p>
                <p className="mb-2">
                  <b>Seating Capacity:</b> 5 Seater  
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="car-list-card">
                <img src={images("./Volvo-Bus.jpg")} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="car-list-card-text mt-20 pl-20">
                <h3 className="mb-2">Mercedes/Volvo Bus</h3>
                <p className="mb-2">
                  <b>Vehicle Type:</b> Mini & Large Bus
                </p>
                <p className="mb-2">
                  <b>Seating Capacity:</b> 18 – 42 Seater
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>

    </>
  );
}

export default Car_Details;
